import { render } from "./K2.vue?vue&type=template&id=6fc6b1b0&scoped=true"
import script from "./K2.vue?vue&type=script&lang=js"
export * from "./K2.vue?vue&type=script&lang=js"

import "./K2.vue?vue&type=style&index=0&id=6fc6b1b0&scoped=true&lang=css"
import "../../assets/styles/p-series-compare.css?vue&type=style&index=1&id=6fc6b1b0&scoped=true&lang=css&external"
import "./K2.vue?vue&type=style&index=2&id=6fc6b1b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fc6b1b0"]])

export default __exports__